export const getFullDate = (data: string) => {
    const year = data && data.replaceAll(".", "-").slice(6, 10);
    const month = data && data.replaceAll(".", "-").slice(3, 5);
    const day = data && data.replaceAll(".", "-").slice(0, 2);
    return new Date(`${year}-${month}-${day}`);
};
